import { IonSlide, IonSlides } from '@ionic/react';
import React from "react";
import Ripples from 'react-ripples';

const slideOpts = {
    slidesPerView: 'auto',
    speed: 400,
    zoom: false
};

type ListProps = {
    history: any,
    categories: any
}

const EstablishmentCategories: React.FC<ListProps> = ({ history, categories }) => {

    const CategoriesElements = categories.map((category: any) => {
        const { name, image, id } = category;

        return (
            <IonSlide className="d-block ml-3" style={{ width: '6rem' }} key={id}>
                <Ripples className="d-block" onClick={() => {
                    setTimeout(function () {
                        history.push(`/category/${id}/${name}/${image.replace(new RegExp('/', 'g'), '%2F')}`);
                    }, 175)
                }}>
                    <img src={image} alt={name} className="rounded-lg shadow-sm" />
                    <p className="my-1 font-weight-bold" style={{fontSize: '13px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{name} </p>
                </Ripples>
            </IonSlide>
        );
    });

    return (

        <IonSlides pager={false} options={slideOpts}>
            {CategoriesElements}
        </IonSlides>
    )
};

export default EstablishmentCategories;